// module_storage coordinates for the workbook, shared so admin copy tooling hits the same row the webapp reads and writes.
export const SCRATCHPAD_MODULE = "scratchpad";
export const SCRATCHPAD_WORKBOOK_KEY = "workbook.v1";
//# sourceMappingURL=constants.js.map